
export function customEventActionDetails() {


  ScenarioCustomEventActionDetailsController.$inject = ['$scope', '$stateParams', 'AngularBasicService'];
  function ScenarioCustomEventActionDetailsController($scope, $stateParams, AngularBasicService) {
    const path = `/#/${$stateParams.companyId}/fuse/parameters/custom-events`;
    $scope.botEventsUrl = AngularBasicService.fullURLForRoutePath(path);

    $scope.selectScenarioCustomEvent = selectScenarioCustomEvent;

    init();

    function selectScenarioCustomEvent(scenarioCustomEvent) {
      $scope.scenarioCustomEventId = scenarioCustomEvent.id;
      $scope.scenarioCustomEventName = `${scenarioCustomEvent.name} (${AngularBasicService.translate(`parameters/custom-events/type/${scenarioCustomEvent.event_type}`)})`;
      $scope.action.scenarioCustomEvent = {
        'id': scenarioCustomEvent.id,
        'name': scenarioCustomEvent.name
      };
    }

    function init() {
      let selectedScenarioCustomEvent = null;
      if ($scope.action.scenarioCustomEvent && $scope.action.scenarioCustomEvent.id) {
        selectedScenarioCustomEvent = $scope.action.scenarioCustomEvent;
      } else if ($scope.scenarioCustomEvents && $scope.scenarioCustomEvents.length > 0) {
        selectedScenarioCustomEvent = $scope.scenarioCustomEvents[0];
      }
      if (selectedScenarioCustomEvent) {
        const botEvent = $scope.scenarioCustomEventsMap.get(selectedScenarioCustomEvent.id)
        selectScenarioCustomEvent(botEvent);
      } else {
        $scope.scenarioCustomEventId = null;
        $scope.scenarioCustomEventName = '';
      }
      $scope.showNameDuplicateWarning = false;
    }
  }


  return {
    restrict: 'E',
    template: require('./custom-event-action-details.directive.html'),
    scope: {
      action: "=",
      scenarioCustomEvents: "=",
      scenarioCustomEventsMap: "=",
      closeModalFn: "&closeModal",
    },
    controller: ScenarioCustomEventActionDetailsController
  };

}
